module.exports = __webpack_public_path__ + "static/media/Primary_Tips.96c7188e.pdf";